import SEO from './components/SEO';

const expectations = [
  {
    title: 'We start with your workflow',
    description:
      "We'll walk through how the work gets done today, where people re-enter data, and which reports and systems the team uses.",
  },
  {
    title: 'We look for the main bottleneck',
    description:
      "Common examples are reports built by hand, slow handoffs, tools that don't share data, and answers that require someone to combine several sources.",
  },
  {
    title: 'We decide whether there is a useful first project',
    description:
      "If there is a fit, we'll outline a possible first project. If there isn't, we'll say so.",
  },
];

export default function CallExpectationsPage() {
  return (
    <>
      <SEO
        title="What to expect on a first call | Greyfield Data"
        description="What we'll discuss on a first call: your current workflow, the main bottleneck, and whether there is a useful first project."
        type="website"
        url="https://www.greyfielddata.com/call-expectations"
        image="https://www.greyfielddata.com/media/call-expectations-thumbnail.png"
        keywords={[
          'Greyfield Data call expectations',
          'data consulting intro call',
          'automation discovery call',
          'what to expect consulting call',
        ]}
      />

      <div className="min-h-screen bg-white font-['Inter'] overflow-x-hidden">
        <section className="relative overflow-hidden bg-slate-50 py-16 md:py-24">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,_rgba(26,78,148,0.08),_transparent_42%)]" />

          <div className="relative mx-auto max-w-4xl px-6">
            <div className="mb-10 text-center">
              <p className="mb-3 text-sm font-semibold uppercase tracking-[0.22em] text-[#1a4e94]">First call</p>
              <h1 className="mb-4 text-4xl font-semibold leading-[1.1] tracking-tight text-slate-900 md:text-5xl">
                What we'll cover on the first call
              </h1>
            </div>

            <div className="overflow-hidden rounded-[2rem] border border-slate-200 bg-slate-950 p-3 shadow-[0_30px_80px_rgba(15,23,42,0.16)]">
              <video
                className="aspect-video w-full rounded-[1.4rem] bg-black object-cover"
                controls
                playsInline
                preload="metadata"
                poster="/media/call-expectations-thumbnail.png"
              >
                <source src="/media/call-expectations.mp4" type="video/mp4" />
                Your browser can't play this video. You can{' '}
                <a href="/media/call-expectations.mp4">download the video</a>.
              </video>
            </div>

            <div className="mt-10 grid gap-4 md:grid-cols-3">
              {expectations.map((item, index) => (
                <article
                  key={item.title}
                  className="rounded-[1.75rem] border border-slate-200 bg-white p-6 shadow-[0_12px_40px_rgba(15,23,42,0.05)]"
                >
                  <div className="mb-4 h-1.5 w-14 rounded-full bg-[#1a4e94]" />
                  <div className="mb-2 text-xs font-semibold uppercase tracking-[0.18em] text-slate-400">
                    Step {index + 1}
                  </div>
                  <h3 className="mb-2 text-xl font-semibold text-slate-900">{item.title}</h3>
                  <p className="leading-relaxed text-slate-500">{item.description}</p>
                </article>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
